import { Point } from '@navstation-portal/shared/data-model/common';

export const PROPELLER_PITCH_MIN = -45;
export const PROPELLER_PITCH_MAX = 45;

export const GAUGE_SWEEP_DEGREES = 45;
export const GAUGE_PIVOT: Point = { x: 50, y: 74 };
export const GAUGE_VIEWBOX_MIN_X = 14;
export const GAUGE_VIEWBOX_WIDTH = 72;
export const GAUGE_VIEWBOX_MIN_Y = 16;
export const GAUGE_VIEWBOX_HEIGHT = 64;
export const GAUGE_PIVOT_Y_RATIO = (GAUGE_PIVOT.y - GAUGE_VIEWBOX_MIN_Y) / GAUGE_VIEWBOX_HEIGHT;
export const GAUGE_TICK_ANGLES = [-45, -30, -15, 0, 15, 30, 45];
export const GAUGE_BAND_OUTER_RADIUS = 34;
export const GAUGE_BAND_INNER_RADIUS = 24;
export const GAUGE_TICK_LENGTH = 4;
export const GAUGE_TICK_OUTER_RADIUS = GAUGE_BAND_OUTER_RADIUS + GAUGE_TICK_LENGTH;
export const GAUGE_ZERO_LABEL_OFFSET = 12;
export const GAUGE_EXTREMITY_LABEL_OFFSET = 8;

export const BLADE_PATH_D =
  'M17.1 21.6245C12.2902 11.4645 6.43699 6.61021 0.500051 0.5C1.2438 3.61242 3.55223 11.9507 7.40008 20.0786C12.2099 30.2386 18.0631 35.093 24 41.2032C23.2563 38.0908 20.9478 29.7525 17.1 21.6245Z';
export const BLADE_ROOT: Point = { x: 24, y: 41.2032 };
export const BLADE_TIP: Point = { x: 0.500051, y: 0.5 };
export const BLADE_LENGTH = 30;
